import { CheckIcon } from '@chakra-ui/icons'
import { MdPeople as PeopleIcon } from 'react-icons/md'
import cx from 'classnames'
import SvgIcon from 'components/SvgIcon'
import { IGroup } from 'interfaces/group'
import styles from '../../shareWithGroupsDialog.module.scss'

interface IGroupOptionProps {
  group: IGroup
  isSelected?: boolean
  toggleGroup: (id: number) => void
  setDeleteGroupId: (id: number) => void
}

const GroupOption = (props: IGroupOptionProps) => {
  const { toggleGroup, setDeleteGroupId, group, isSelected } = props

  return (
    <div className={cx(styles.itemWrapper, { [styles.selectedItem]: isSelected })}>
      <div
        className={styles.nameWrapper}
        onClick={() => {
          toggleGroup(Number(group.id))
        }}
      >
        <div className={styles.iconWrapper}>
          <PeopleIcon />
        </div>{' '}
        <span>{group.name}</span>
        {isSelected && <CheckIcon className={styles.checkIcon} />}{' '}
      </div>
      {/* FontAwesome 7 dropped the fas fa-trash-alt glyph — use the repo SVG icon instead. */}
      <SvgIcon
        iconName="ic_outline-delete"
        size={16}
        style={{ cursor: 'pointer', flexShrink: 0 }}
        onClick={() => {
          setDeleteGroupId(group.id ?? 0)
        }}
      />
    </div>
  )
}

export default GroupOption
